// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoOkta } from '../../../assets/images/Logos/logo-okta.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoOktaIcon = /* @__PURE__ */ withLogoClass(LogoOkta);
